import insertNewQuestionnaireInstanceBatch from '../data_management/insertNewQuestionnaireInstanceBatch'

class EmailInteractor {
  constructor(initialDataInteractor, dataService, coachGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.dataService = dataService;
    this.coachGateway = coachGateway;
  }

  sendReminderEmailToPerson(questionnaireInstanceId, messageHtml) {
    return this.coachGateway.sendReminderToPerson(this.dataService.secretKey, {
      message_html: messageHtml,
      id: questionnaireInstanceId
    })
  };

  sendQuestionnaireEmailToWorkspace(questionnaireId, workspaceId, messageHTML, openReports) {
    let data = {
      'questionnaire_id': questionnaireId,
      'workspace_id': workspaceId,
      'message_html': messageHTML,
      'open_reports': openReports
    };
    return this.coachGateway.sendQuestionnaireToWorkspace(this.dataService.secretKey, data)
      .then(response => {
        insertNewQuestionnaireInstanceBatch(this.initialDataInteractor, response);
        return response;
      });
  };

  sendInvestigationReminder(message, investigation) {
    return this.coachGateway.sendInvestigationReminder(this.dataService.secretKey, message, investigation);
  };

}

export default EmailInteractor